var React = require('react');

function LargeArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.121 2 5.061.94 0 6l5.06 5.06L6.122 10l-3.25-3.25H24v-1.5H2.871L6.121 2Z","fill":"#1C1C1C"}));
}

LargeArrow.defaultProps = {"width":"24","height":"12","fill":"none"};

module.exports = LargeArrow;

LargeArrow.default = LargeArrow;
